<!-- ================管理端-推荐书目====================-->
<template>
    <div class="admin-screen-container">
        <div class="admin-title-container">书目列表</div>
        <div class="admin-btn-container">
            <div class="admin-btn-item" @click="handleCreate">添加书目</div>
        </div>
        <div class="admin-search4-100">
            <div class="admin-search25">
                <div class="admin-search25-name">所属主题:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="pageList(null)"
                               v-model="queryParams.bookItem" placeholder="请选择">
                        <el-option v-for="item in itemList" :key="item.itemId" :label="item.itemMonth+' '+item.itemName"
                                   :value="item.itemId" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25">
                <div class="admin-search25-name">所属学段:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="pageList(null)"
                               v-model="queryParams.periodKey" placeholder="请选择">
                        <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                   :value="item.dictKey" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25">
                <div class="admin-search25-name">年级段:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="pageList(null)"
                               v-model="queryParams.bookGrade" placeholder="请选择">
                        <el-option v-for="item in itemGradeList" :key="item.dictKey" :label="item.dictValue"
                                   :value="item.dictKey" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25">
                <div class="admin-search25-item-input">
                    <el-input class="admin-input1" v-model="queryParams.bookName" placeholder="请输入书目名称" >
                        <template #append>
                            <el-button @click="handleQuery" class="name-search-btn"
                                       type="primary" icon="el-icon-search" />
                        </template>
                    </el-input>
                </div>
            </div>
        </div>
        <!--数据列表-->
        <div class="mt5">
            <el-table v-loading="loading"
                      cell-class-name="admin-table"
                      show-overflow-tooltip
                      height="calc(100vh - 255px)"
                      :data="dataList"
                      class="admin-table"
                      highlight-current-row>
                <el-table-column type="index"  fixed="left" align="center" label="序号" width="60" />
                <el-table-column  width="280" label="书目名称" align="center" prop="bookName">
                    <template #default="scope">
                        <div :title="scope.row.bookName" @click="handleDetail(scope.row)" style="color: #377f7f;" class="text-one cursor">
                            {{ scope.row.bookName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="240" label="作者" align="center" prop="bookAuthor">
                </el-table-column>
                <el-table-column width="200"  label="主题" align="center" prop="bookItemName">
                    <template #default="scope">
                        <div :title="scope.row.bookItemName"
                             class="text-one cursor">
                            {{ scope.row.bookItemName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="140" label="学段·年级" align="center" prop="">
                    <template #default="scope">
                        <div :title="scope.row.periodName+''+scope.row.gradeName"
                             class="text-one cursor">
                            {{ scope.row.periodName }} {{ scope.row.gradeName?'| '+scope.row.gradeName: ''}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="100" label="年级段" align="center" prop="">
                    <template #default="scope">
                        <div :title="scope.row.bookGradeName"
                             class="text-one cursor">
                            {{ scope.row.bookGradeName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="120" label="出版时间" align="center" prop="publishTime">
                    <template #default="scope">
                        <div>{{ timestampDate(scope.row.publishTime) }}</div>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" width="100" align="center" label="操作"
                                 class-name="small-padding fixed-width">
                    <template #default="scope">
                        <el-popover placement="bottom" trigger="click"
                                    :width="80" popper-style="padding: 5px 0 0">
                            <template #reference>
                                <el-button type="primary" size="default">操作</el-button>
                            </template>
                            <template #default>
                                <div>
                                    <div class="text-item">
                                        <el-text type="primary" @click="handleDetail(scope.row)">查看</el-text>
                                    </div>
                                    <div class="text-item">
                                        <el-text type="primary" @click="handleUpdate(scope.row)">编辑</el-text>
                                    </div>
                                    <div class="text-item">
                                        <el-popconfirm
                                          confirm-button-text="是"
                                          cancel-button-text="否"
                                          icon-color="#626AEF"
                                          title="确定删除?"
                                          @confirm="handleDelete(scope.row)">
                                            <template #reference>
                                                <el-text type="danger">删除</el-text>
                                            </template>
                                        </el-popconfirm>
                                    </div>

                                </div>
                            </template>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--  分页  -->
        <div>
            <pagination :background="false"
                        :pageSizes="[10, 20, 30]"
                        :total="total"
                        :page.sync="queryParams.pageNum"
                        :limit.sync="queryParams.pageSize"
                        @pagination="pageList" />
        </div>
    </div>

</template>
<script>
import {deleteBook, pageBook} from "@/api/admin/book";
import {queryDict} from "@/api/admin/dict";
import {listItem} from "@/api/admin/item";
import {timestampDate, timestampToTime} from "@/utils/date";

export default {
    components: {},
    name: "bookIndex",
    data() {
        return {
            timestampToTime,
            timestampDate,
            loading: false,
            /*分页查询一级代理商*/
            queryParams:{
                bookName:'',
                bookItem:'',
                periodKey:'',
                gradeKey:'',
                bookGrade:'',
                pageNum: 1,
                pageSize: 10,
            },
            dataList:[],
            total:0,
            periodList:[],
            itemGradeList:'',
            queryItemParams:{
                itemType:1,
                museumKey:'1',
            },
            itemList:[],
        }
    },
    computed: {},
    watch: {},
    created() {
        this.pageList();
        this.handleQueryDict();
        this.handleQueryItem();
    },
    mounted() {},
    methods: {
        /*===========数据查询============*/
        handleQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
            queryDict({ code: 'grade_period' }).then(res => {
                this.itemGradeList = res.data.data;
            })
        },
        handleQueryItem(){
            listItem(this.queryItemParams).then(res => {
                if (res.data.code === 1) {
                    this.itemList = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        handleQuery(){
            this.pageList(null);
        },
        pageList(e){
            this.loading = true
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageBook(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                    this.loading = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading = false;
                }
            })
        },
        handleDelete(row){
            deleteBook({ bookId: row.bookId }).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.pageList(null);
                } else {
                    this.$message.error("操作失败");
                }
            })
        },
        handleCreate(){
            this.$router.push({
                path: "/bookCreate",
            });
        },
        handleUpdate(row){
            this.$router.push({
                path: "/bookCreate",
                query: {
                    bookId: row.bookId,
                }
            });
        },
        handleDetail(row){
            this.$router.push({
                path: "/bookDetail",
                query: {
                    bookId: row.bookId,
                }
            });
        },
    },
}
</script>
<style scoped>
.admin-select1{
    width: 90px;
}
.admin-select1 /deep/ .el-select__wrapper {
    height: 30px; /* 高度 */
    line-height: 28px;
    min-height: 30px!important;
}
.admin-input1 /deep/ .el-input__wrapper {
    height: 30px; /* 高度 */
    line-height: 28px;
    min-height: 30px!important;
}
.name-search-btn{
    background-color: #377f7f!important;
    color: #fff!important;
}

</style>
